module.exports = __webpack_public_path__ + "static/media/drdiary_04.c2615885.png";